import {Component, Input} from '@angular/core';
import {Group} from "../../model/group";
import {ModalsService} from "../../services/modals.service";

@Component({
  selector: '[app-group-item]',
  templateUrl: './group-item.component.html',
  styleUrls: ['./group-item.component.css']
})
export class GroupItemComponent {
  @Input() showControls: boolean;
  @Input() group: Group;

  constructor(private readonly modalsService: ModalsService) {
  }

  info(): void {
    this.modalsService.showGroupInfo(this.group);
  }
}
